import { useMutation } from "react-query";
import { LogenInstance, LotteInstance } from "../instance";
import Swal from "sweetalert2";
import { useRecoilValue } from "recoil";
import { loginState } from "../../stores/loginState";

// TODO 고객사 데이터 즉시전송 API
export const useSendInvoice = ({ startDate, endDate }) => {
  // NOTE 상태 변수 선언
  const login = useRecoilValue(loginState); // 로그인 전역변수

  // TODO API 리퀘스트 정보
  const sendInvoice = async () => {
    const requestPayload = {
      api: "sendSelect",
      data: [
        {
          bran_cd: login.company === "LOGEN" ? login.branchCode : login.userId,
          start_time: `${startDate} 00:00:00`,
          end_time: `${endDate} 23:59:59`,
          longTime: "",
        },
      ],
    };

    const instance = login.company === "LOGEN" ? LogenInstance : LotteInstance;
    const response = await instance.post("/send", requestPayload);
    // 각 고객사 Axios interceptor가 이미 response.data를 반환한다.
    // 다시 .data를 읽으면 성공 응답이 undefined가 되어 완료 처리가 깨진다.
    return response;
  };

  // TODO API 결과
  return useMutation(
    "sendInvoice",
    sendInvoice,
    {
      // 성공 시
      onSuccess: (data) => {
        if (data.result === "00" || data.result === "77") {
          // 본사 오류 시
          const failList = data.data?.[0]?.fail_list || [];
          if (login.company === "LOTTE" && failList.length > 0) {
            Swal.fire({
              title: "Error!",
              icon: "error",
              text: `${failList[0]}`,
              confirmButtonText: "확인",
            });
          } else {
            // 성공 시
            Swal.fire({
              icon: "success",
              title: "전송 완료되었습니다!",
              confirmButtonText: "확인",
            });
          }
        }
      },
      // 실패 시
      onError: (error) => {
        console.log(error);
      },
    }
  );
};
